import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminLayout from "./layouts/AdminLayout";
import Sitelayout from "./layouts/Sitelayout";
import NotFound from "./pages/NotFound";

// Pages Site
import AccueilSite from "./pages/site/Accueil";
import QuiSommesNous from "./pages/site/QuiSommesNous";
import NosMeditations from "./pages/site/NosMeditations";
import Contact from "./pages/site/Contact";

// Pages Admin
import Accueil from "./pages/admin/Welcome";
import Connexion from "./pages/admin/FormLogin";
import Dashboard from "./pages/admin/Dashboard";
import Statistiques from "./pages/admin/Statistiques";
import Meditations from "./pages/admin/Meditations";
import Gestion from "./pages/admin/Gestion";
import Publier from "./pages/admin/Publier";
import Messages from "./pages/admin/Messages";
import Parametres from "./pages/admin/Parametres";
import Partenaire from "./pages/admin/Partenaire";
import Temoignages from "./pages/admin/Temoignages";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* Routes de l'application administrateur */}
        <Route path="/connexion-admin" element={<AdminLayout />}>
            <Route index element={<Connexion />} />
            <Route path="admin-connected" element={<Accueil />} />
            <Route path="dashboard" element={<Dashboard />}>
              <Route index element={<Statistiques />} />
              <Route path="meditations" element={<Meditations />} />
              <Route path="gestion" element={<Gestion />} />
              <Route path="publier" element={<Publier />} />
              <Route path="messages" element={<Messages />} />
              <Route path="parametres" element={<Parametres />} />
              <Route path="partenaires" element={<Partenaire />} />
              <Route path="temoignages" element={<Temoignages />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="*" element={<NotFound />} />
        </Route>

        {/* Routes du site */}
        <Route path="/" element={<Sitelayout />}>
          <Route index element={<AccueilSite />} />
          <Route path="qui-sommes-nous" element={<QuiSommesNous />} />
          <Route path="nos-meditations" element={<NosMeditations />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
